import styled from "styled-components";

export const Wrap = styled.section`
  background: transparent;
  color: #111;
  padding: 36px 12px 25px 12px;
`;

export const Inner = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  display: grid;
  grid-template-columns: 1fr 1.15fr; /* imagine stânga, text dreapta */
  gap: clamp(20px, 4vw, 48px);
  @media (max-width: 900px) {
    grid-template-columns: 1fr;
  }
`;

export const Right = styled.div`
  grid-column: 1; /* stânga */
  grid-row: 1; /* 🔥 același rând cu textul */
  align-self: center;
  @media (max-width: 900px) {
    grid-column: auto;
    grid-row: auto;
  }
`;

export const Left = styled.div`
  grid-column: 2; /* dreapta */
  grid-row: 1; /* 🔥 același rând cu imaginea */
  @media (max-width: 900px) {
    grid-column: auto;
    grid-row: auto;
  }
`;

export const Image = styled.img`
  width: 100%;
  max-height: 520px;
  object-fit: cover;
  border-radius: 16px;
  box-shadow: 0 6px 26px rgba(0, 0, 0, 0.12);
  display: block;
`;

export const Eyebrow = styled.div`
  color: #a78631;
  font-weight: 700;
  letter-spacing: 0.3px;
  margin-bottom: 8px;
  font-size: 18px;
  @media (max-width: 900px) {
    font-size: 14px;
  }
`;

export const Title = styled.h2`
  margin: 0;
  font-size: 30px;
  line-height: 1.12;
  font-weight: 900;

  @media (max-width: 900px) {
    font-size: clamp(24px, 4.6vw, 44px);
  }
`;

export const Text = styled.p`
  margin: 10px 0;
  font-size: clamp(14px, 1.7vw, 18px);
  line-height: 1.7;
  opacity: 0.95;
`;

export const Actions = styled.div`
  margin-top: 16px;
`;

export const PrimaryBtn = styled.button`
  background: #111;
  color: #fff;
  border: 0;
  border-radius: 12px;
  padding: 12px 18px;
  font-weight: 800;
  cursor: pointer;
  transition: transform 0.15s ease, filter 0.15s ease;
  display: inline-flex;
  align-items: center;
  gap: 10px;
  &:hover {
    transform: translateY(-1px);
    filter: brightness(1.05);
  }
`;
